export type SizeType = {
  mobileS: string;
  mobileM: string;
  mobileL: string;
  tablet: string;
  laptopS: string;
  laptop: string;
  laptopMui: string;
  smMui: string;
  laptopM: string;
  laptopL: string;
  desktop: string;
};

export const size: SizeType = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "710px",
  laptopS: "995px",
  smMui: "600px",
  laptop: "1070px",
  laptopMui: "1200px",
  laptopM: "1248px",
  laptopL: "1440px",
  desktop: "2560px",
};
